define('glu/grid/filter/numberRangeSearch',['require','./fieldSearch','./amountSearch','../../core/internal/masking'],function(require) {
    'use strict';

    var FieldSearch = require('./fieldSearch'),
        AmountSearch = require('./amountSearch');

    require('../../core/internal/masking');

    return AmountSearch.extend({
        onRender: function() {
            FieldSearch.prototype.onRender.call(this);
            this.ui.$focusField.maskNumeric();
            this.showDropdown();
        },

        onClose: function() {
            this.ui.$focusField.unmask();
        }
    });
});

